import { Box } from '@mui/material';
import type { FC } from 'react';
import type { Session } from '../../../core/domain/Session';
import ArrowUpIcon from '../../../assets/icons/arrow-up.svg?react';
import ArrowDownIcon from '../../../assets/icons/arrow-down.svg?react';

type RoadDirectionProps = {
    session: Session;
};
export const RoadDirection: FC<RoadDirectionProps> = ({ session }) => (
    <Box onClick={(e) => e.stopPropagation()}>
        {session.metadata.roadDirection === 'D - Sens aller' ? <ArrowUpIcon /> : <ArrowDownIcon />}
    </Box>
);
